import { __assign } from "tslib";
import React, { forwardRef, useCallback } from 'react';
import { CheckWithLabelBase } from '../internal/CheckWithLabelBase/CheckWithLabelBase';
import { PureCheckbox } from '../PureCheckbox/PureCheckbox';
export var Checkbox = forwardRef(function (props, ref) {
    var indeterminate = props.indeterminate;
    /* To support indeterminate. Choose this over a render function, because
     * of all the check-like components, this is the exception and just passing the component,
     * leads to simpler code overall (expect here). */
    var checkComponent = useCallback(function (pureCheckboxProps) {
        return (React.createElement(PureCheckbox, __assign({}, pureCheckboxProps, { indeterminate: indeterminate })));
    }, [indeterminate]);
    return (React.createElement(CheckWithLabelBase, __assign({}, props, { ref: ref, CheckComponent: checkComponent })));
});
//# sourceMappingURL=Checkbox.js.map